<template>
  <div class="addProject">
    <h3 class="title">{{title}}</h3>
    <el-form :rules="menuType!=2?rules:{}" label-width="120px" :model="formData" ref="formData">
      <div class="card">
        <el-form-item label="手术(治疗)名称" prop="operationName">
          <el-input v-model="formData.operationName" placeholder="请输入手术(治疗)名称" @input="testSX" style="width:90%;"></el-input>
        </el-form-item>
        <el-form-item label="麻醉方式" prop="anesthesiaMode">
          <el-radio-group v-model="formData.anesthesiaMode">
            <el-radio :label="'0'">其他</el-radio>
            <el-radio :label="'1'">全麻</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="手术细则说明" prop="operationExplain">
          <el-input v-model="formData.operationExplain" placeholder="请输入手术细则说明" @input="testSX" style="width:90%;"></el-input>
        </el-form-item>
        <el-form-item label="原手术名称">
          <el-input v-model="formData.agoOperationName" placeholder="请输入原手术名称" @input="testSX" style="width:90%;"></el-input>
        </el-form-item>
        <div>
          <div v-for="(domain, idx) in formData.diagnosisMenuList" :key="idx">
            <el-form-item label="诊断">
              <div class="flex">
                <el-input style="width:90%;" v-model="domain.diagnosisName" placeholder="请输入诊断" @input="testSX"></el-input>
                <el-button size="mini" type="danger" @click.prevent="edit(domain,idx)" v-show="idx > 0">
                  <i class="el-icon-delete"></i>
                </el-button>
              </div>
            </el-form-item>
          </div>
          <el-form-item style="text-align: right;margin-right:5%;">
            <el-button @click="add" type="primary" size="mini">新增诊断</el-button>
          </el-form-item>
        </div>

        <el-form-item label="说明" prop="detailsExplain">
          <el-input v-model="formData.detailsExplain" placeholder="请输入说明" @input="testSX" style="width:90%;"></el-input>
        </el-form-item>
        <el-form-item label="手术编号" prop="operationNo">
          <el-input v-model="formData.operationNo" placeholder="请输入手术编号" @input="testSX" style="width:90%;"></el-input>
        </el-form-item>
        <el-form-item label="手术级别" prop="operationGrade">
          <el-select v-model="formData.operationGrade" placeholder="请选择手术级别" style="width:90%">
            <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="治疗指数" prop="therapeuticType">
          <el-radio-group v-model="formData.therapeuticType">
            <el-radio :label="1">每单位</el-radio>
            <el-radio :label="2">数值</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="" prop="operationIndex">
          <el-input oninput="value=value.replace(/[^0-9.]/g, '')" v-model="formData.operationIndex" placeholder="请输入治疗指数" @input="testSX" style="width:30%;"></el-input>
          <el-input v-if="formData.therapeuticType==1" v-model="formData.therapeuticUnits" placeholder="请输入治疗指数单位" @input="testSX" style="width:30%;"></el-input>
        </el-form-item>
        <el-form-item label="登记表" prop="registerType">
          <!-- :disabled="disabled" -->
          <el-radio-group v-model="formData.registerType">
            <el-radio label="1">外科</el-radio>
            <el-radio label="2">注射微整科</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
      <div class="footer">
        <el-form-item>
          <el-button type="danger" @click="resetForm('formData')">取 消</el-button>
          <el-button type="primary" @click="doAddgoods('formData')">确 定</el-button>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>
<script>
export default {
  props: ['code', 'formData', 'menuType'],
  data() {
    return {
      title: '',
      disabled: false,
      radio: '',
      rules: {
        operationName: [
          { required: true, message: '请输入手术治疗名称', trigger: 'blur' },
        ],
        anesthesiaMode: [
          { required: true, message: '请选择麻醉方式', trigger: 'blur' },
        ],
        therapeuticType: [
          { required: true, message: '请选择治疗指数', trigger: 'blur' },
        ],
        operationIndex: [
          { required: true, message: '请输入治疗指数值', trigger: 'blur' },
        ],
        registerType: [
          { required: true, message: '请选择登记表类型', trigger: 'blur' },
        ],
      },
      options: [
        {
          name: '一级',
          id: '1',
        },
        {
          name: '二级',
          id: '2',
        },
        {
          name: '三级',
          id: '3',
        },
        {
          name: '四级',
          id: '4',
        },
      ]
    }
  },
  created() {
    if (this.code == 0) {
      this.title = '新增诊断'
      this.disabled = false
    } else if (this.code == 1) {
      this.title = '编辑诊断'
      this.disabled = false
    } else if (this.code == 2) {
      this.title = '复制诊断'
      this.disabled = false
    }
  },
  methods: {
    testSX() {
      this.$forceUpdate()
    },
    doAddgoods(formData) {
      let createBy = Lockr.get("skinEmpId");
      this.formData.createBy = createBy
      //   新增数据
      this.$refs[formData].validate((valid) => {
        if (valid) {
          if (this.code == 0 || this.code == 2) {
            let arr1 = this.formData.diagnosisMenuList.map((item, index) => {
              return item.diagnosisName;
            });
            let querys = {
              operationName: this.formData.operationName,
              agoOperationName: this.formData.agoOperationName,
              operationExplain: this.formData.operationExplain,
              detailsExplain: this.formData.detailsExplain,
              operationNo: this.formData.operationNo,
              operationIndex: this.formData.operationIndex,
              therapeuticType: this.formData.therapeuticType,
              registerType: this.formData.registerType,
              diagnosisName: arr1.toString(),
              createBy: this.formData.createBy,
              therapeuticUnits: this.formData.therapeuticUnits,
              anesthesiaMode: this.formData.anesthesiaMode,
              operationGrade: this.formData.operationGrade,
            }
            api.requestQuiet("/register/createOperationMenu", querys, (res) => {
              if (res.result == true) {
                _g.toast("success", '新增成功!');
                this.$emit('add-comment')
                this.$emit('closeDialog')
              } else {
                _g.toast("error", '新增失败!');
              }
            }, (err) => {
              this.loading = false
            })
          } else if (this.code == 1) {//修改数据
            api.requestQuiet("/register/updateOperationMenu", this.formData, (res) => {
              if (res.result == true) {
                _g.toast("success", '修改成功!');
                this.$emit('add-comment')
                this.$emit('closeDialog')
              } else {
                _g.toast("error", '修改失败!');
              }
            }, (err) => {
              this.loading = false
            })
          }
        }
      })
    },
    resetForm() {
      this.$emit('closeDialog')
    },
    // 编辑时删除手术名称
    editRemoveDomain(item, listIndex) {
      var index = this.formData.operationNameList.indexOf(item)
      if (index !== -1) {
        this.formData.operationNameList.splice(listIndex, 1)
      }
      this.$forceUpdate()
    },
    // 编辑时新增手术名称
    editDomain() {
      this.formData.operationNameList.push({
        operationName: "",
        key: Date.now()
      });
      this.$forceUpdate()
    },

    // 编辑时删除诊断
    edit(item, listIndex) {
      var index = this.formData.diagnosisMenuList.indexOf(item)
      if (index !== -1) {
        this.formData.diagnosisMenuList.splice(listIndex, 1)
      }
      this.$forceUpdate()
    },
    // 编辑时新增诊断
    add() {
      this.formData.diagnosisMenuList.push({
        menuName: "",
        key: Date.now()
      });
      this.$forceUpdate()
    },
  }
}
</script>
<style scoped>
.footer {
  display: flex;
  justify-content: space-around;
  margin-top: 60px;
}
.sure {
  margin-left: 50px;
}
.title {
  text-align: center;
  margin-bottom: 30px;
}
.addProject >>> .el-form-item__content {
  line-height: 40px !important;
}
.flex {
  display: flex;
  align-items: flex-start;
}
.flex >>> .el-button i {
  margin: 0 !important;
}
.flex >>> .el-button--mini {
  margin: 8px;
}

.footer >>> .el-form-item__content {
  margin-left: 0 !important;
}
</style>